document.addEventListener('DOMContentLoaded', function() {

    let sliderArrow = typeof webmagazinSliderArrow !== 'undefined' ? webmagazinSliderArrow : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>';
    $('.printed-issues-further-issues-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        prevArrow: `<button type="button" class="slick-prev slick-arrow">${sliderArrow}</button>`,
        nextArrow: `<button type="button" class="slick-next slick-arrow">${sliderArrow}</button>`,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

});